<template>
  <v-footer
    app
    height="40"
  >
    <div class="text-caption text-disabled">
      <span class="d-none d-inline-block">v{{ appStore.version }}</span>
    </div>

    <v-spacer />

    <div class="text-caption text-disabled">
      &copy; {{ new Date().getFullYear() }}
      <a
        class="text-decoration-none on-surface"
        href="https://otodev.gr/"
        rel="noopener noreferrer"
        target="_blank"
      >
        <span class="d-none d-inline-block">OTODEV</span>
      </a>
    </div>
  </v-footer>
</template>

<script setup>
  import { useAppStore } from '@/stores/appStore.js'

  const appStore = useAppStore()
</script>

<style scoped>

</style>
